export const he = {
    "TRIGGER_LISTEN": "מאזין לגירויים",
    "ASSIST_EMPTY_MSG": "הסוכן AI מאזין לשיחה שלך ומוכן לעזור אוטומטית כשיתבקש.",
    "MYBOT_TRIGGET_LISTEN": "אין משימות פעולות ב-My Bot כעת",
    "MYBOT_EMTPY_MSG": "כדי להתחיל משימה ב-My Bot, עבור ללשונית החיפוש ובחר באופציה \"הפעל עם קלטי סוכן\" למשימה הרצויה.",
    "PROACTIVE_MODE": "מצב פרואקטיבי",
    "SETTINGS": "הגדרות",
    "HELP_AND_SUPPORT": "עזרה ותמיכה",
    "HELP": "עזרה",
    "PLAYBOOK": "ספר משחק",
    "LANGUAGE": "שפה",
    "THEME": "נושא",
    "AUTOMATIC": "אוטומטי",
    "FILE_NAME":"שם הקובץ",
    "AUTO_SCROLL_TOOLTIP":"שולט בגלילה האוטומטית של לשונית הסיוע, הבוט שלי ותוכן לשונית התמלול",
    "DARK": "כהה",
    "LIGHT": "בהיר",
    "THEME_DESC": "זה ישתמש במצב ברירת המחדל של המערכת שלך",
    "DOCUMENTATION": "תיעוד",
    "DOC_DESC": "בדוק את המאמרים המעמיקים שלנו.",
    "FAQ_U": "שאלות נפוצות",
    "FAQ_DESC": "בדוק שאלות נפוצות על Agent AI.",
    "TAB_TEXT":"אין כרטיסיות זמינות! אנא הפעל לפחות כרטיסיה אחת",
    "KORE_ACADEMY": "אקדמיית קור",
    "KORE_ACA_DESC": "למד עוד על Agent AI דרך הקורסים באקדמיה.",
    "SEARCH": "חפש",
    "MY_BOT": "הבוט שלי",
    "ASSIST": "עזור",
    "TRANSCRIPT": "תמלול",
    "HISTORY": "היסטוריה",
    "TAP_SEARCH":"הקש לחיפוש",
    "STARTOVER": "התחל מחדש",
    "RESTART_INPUTS": "התחל מחדש עם קלטים שהוקלטו",
    "ASKCUSTOMER": "שאל את הלקוח",
    "TELLCUSTOMER": "אמר ללקוח",
    "WELCOME_MSG": "הודעת ברוך הבא",
    "SEND": "שלח",
    "SENT": "נשלח",
    "AWAITING": "מחכה לתגובה | הקלד כדי להמשיך",
    "OVERRIDE": "הקלד כדי להמשיך",
    "OVERRIDE_FILE": "צרף קובץ כדי להמשיך",
    "ACCEPT_RESPONSE": "תגובה התקבלה",
    "AGENT_ENTERED": "סוכן נכנס",
    "EXPECTED_FORMAT": "פורמט צפוי",
    "INPUT_VALUES": "ערכי קלט",
    "RESTART": "התחל מחדש",
    "START_OVER": "התחל מחדש",
    "RESTART_CAPTURE": "התחל מחדש עם קלטים שהוקלטו",
    "CANCEL": "ביטול",
    "INTERRUPT_DIALOG": "משימת דיאלוג הופסקה",
    "RUN": "הרץ",
    "RUN_AGENT": "הרץ עם קלט הסוכן",
    "STEP": "שלב",
    "DIALOG_TASK": "משימת דיאלוג",
    "FAQ": "שאלות נפוצות",
    "SNIPPET": "תשובות",
    "ARTICLE": "דפי אינטרנט",
    "FILE": "קבצים",
    "SUGGESTED": "מומלץ",
    "ALL_DIALOG": "כל משימות הדיאלוג",
    "DIALOG_TEXT": "דיאלוג",
    "INTENT_IDENTIFIED": "הבעת לקוח",
    "NOT_WHAT_LOOKING": "הצעה לא נכונה?",
    "BOT": "בוט",
    "CUSTOMER": "לקוח",
    "YOU": "אתה",
    "TERMINATE_CONV": "סיים משימת דיאלוג",
    "TERMINATE_CONV_DESC": "האם אתה בטוח שתרצה לסיים את משימת הדיאלוג? סוכן AI לא יוכל להציע יותר.",
    "YES_TERMINATE": "כן, סיים",
    "NO_CANCEL": "לא, בטל",
    "OVERRIDE_CONTINUE": "המשך במצב מעקף",
    "SUMMARY_TEXT": "סיכום",
    "SUBMIT": "שלח",
    "INTERRUPT_OCCURED": "הפסקה התרחשה",
    "IDENTIFIED_INTENT": "כוונה מזוהה",
    "INTERRUPT_DESC": "הרצת זאת תסיים את משימת הדיאלוג שלך.",
    "ACCEPT_RUN": "קבל והריץ",
    "RUN_LATER": "הרץ מאוחר יותר",
    "KNOW_MORE": "למד עוד",
    "MORE_TEXT": "יותר",
    "LESS_TEXT": "פחות",
    "VIEW_MORE": "הצג יותר",
    "VIEW_LESS": "הצג פחות",
    "SHOW_MORE_FAQ": "הצג עוד שאלות נפוצות",
    "SHOW_LESS_FAQ": "הצג פחות שאלות נפוצות",
    "SHOW_MORE_ARTICLE": "הצג עוד דפי אינטרנט",
    "SHOW_LESS_ARTICLE": "הצג פחות דפי אינטרנט",
    "SHOW_MORE_SNIPPET": "הצג עוד תשובות",
    "SHOW_LESS_SNIPPET": "הצג פחות תשובות",
    "SHOW_MORE_FILES": "הצג יותר קבצים",
    "SHOW_LESS_FILES": "הצג פחות קבצים",
    "VIEW_ALL_DIALOG": "הצג את כל הדיאלוגים",
    "VIEW_FEW_DIALOG": "הצג כמה דיאלוגים",
    "HELP_FULL": "מועיל?",
    "THANKYOU": "תודה!",
    "EXPAND_MORE": "הרחב / יותר",
    "CLOSE_TEXT": "סגור",
    "STARTED": "החל",
    "ENDED": "הסתיים",
    "VIEW_FULL_ARTICLE": "הצג דף אינטרנט",
    "VIEW_FULL_FILE": "הצג קובץ",
    "COPIED": "הועתק",
    "SENTI_ANALY": "ניתוח רגש",
    "WRONG_SUGGESTION": "הצעות לא נכונות",
    "INCORRECT_INTENT": "כוונה לא נכונה",
    "ACCIDENTAL_CLICK": "לחיצה לא מכוונת",
    "TIME_TAKING": "לוקח זמן",
    "OTHER": "אחר",
    "PLAYBOOK_EMPTY_MSG": "בחר תסריט",
    "PLAYBOOK_EMPTY_DESC": "סוכן AI לא מצליח לטעון את התסריט משום שכל התסריטים הזמינים דינמיים. לחץ על 'בחר תסריט' כדי לגשת לתסריט",
    "STAGE": "שלב",
    "PROCEED_TO_CLOSE": "המשך לסגור",
    "RECOMENDED_PLAYBOOK": "תסריט מומלץ",
    "PRIMARY_SCRIPTS": "תסריטים ראשיים",
    "DYNAMIC_SCRIPTS": "תסריטים דינמיים",
    "RESUME": "המשך",
    "ENABLE_CLOSE": "לחץ על כפתור ההמשך לסגירה כדי לאפשר שלב סגירה",
    "LIST_VIEW": "תצוגת רשימה",
    "TERMINATE": "סיים",
    "MINIMIZE": "מזער",
    "MAXIMIZE": "מקסם",
    "NO_SEARCH_RESULT": "לא נמצאו תוצאות חיפוש",
    "SENTIMENT_AWAITING": "מחכה לרגש",
    "POSITIVE": "חיובי",
    "NEGATIVE": "שלילי",
    "ASSOCIATED_WORK_NOTES": "הערות פתרון קודמות",
    "AGENT_JOINED_CONV": "סוכן הצטרף לשיחה",
    "AUTOSCROLL_ASSIST": "עזרה בגלילה אוטומטית בתוכן הטאב",
    "FILE_SIZE_MSG": "גודל הקובץ חייב להיות עד 25MB. בבקשה נסה שוב.",
    "OVERRIDE_BTN": "עקוף",
    "CHOOSE_FILE": "בחר קובץ",
    "SUMMARY_ERROR_TEXT": "אנחנו מצטערים, אך הייתה בעיה ביצירת הסיכום לשיחה זו. אנא צור סיכום בעצמך.",
    "ASK_A_QUESTION": "שאל שאלה",
    "COPY": "העתק",
    "TELL_US_MORE": "ספר לנו עוד…",
    "THANKS_FEEDBACK": "תודה על המשוב שלך",
    "SOMETHING_WRONG": "משהו השתבש",
    "CLICK_ERROR_DETAILS": "לחץ כדי לראות פרטי שגיאה",
    "NO_ACTIVE_PLAYBOOK": "אין ספר משחק פעיל",
    "REPHRASE_QUESTION": "האם תוכל לנסח מחדש את השאלה שלך או לשאול משהו אחר?",
    "INTERNAL_INFO": "מידע פנימי",
    "SOURCES": "מקורות",
    "CONVERSATION_SUMMARY": "סיכום השיחה",
    "WAITING": "ממתין",
    "WIDGET_DISABLED": "הווידג'טמְנֹעָל",
    "AI_SETTINGS_DISABLED": "הגדרות ה-AIמְנֹעָל! אנא פנה למנהל ה-AI",
    "SERVER_CONNECTION_ERROR": "שגיאה בעת חיבור לשרת",
    "VIEW": "צפה",
    "ATTACHMENT_INPUT": "קלט קובץ מצורף",
    "TYPE_SUMMARY": "הקלד סיכום",
    "VIEW_FULL_ARTICLE_2": "צפה במאמר המלא",
    "VIEW_FULL_FILE_2": "צפה בקובץ המלא",
    "BY":"על ידי",
    GENERATE_SUMMARY: "צור סיכום",
    PREV_SUMMARIES: "סיכומים שנוצרו בעבר",
    DIALOG_WORKFLOWS: "זרימות עבודה של דיאלוג",
    SHOW_ALL_DIALOG: "הצג את כל משימות הדיאלוג",
    SHOW_ALL_DIALOGS: "הצג את כל הדיאלוגים",
    CUSTOM_TAB: "לשונית מותאמת אישית",
    AGENT_INPUT: "קלט הסוכן",
    "CUSTOM_EMPTY_MSG" : "אין זרימת עבודה פעילה כעת",
    "CUSTOM_TAB_DESC" : "כדי להתחיל זרימת עבודה, בצע אחת מהזרימות המוצגות בסרגל התחתון של המסך.",
    "SUBMIT_OVERALL_FEEDBACK" : "שלח משוב כללי",
    "FEEDBACK_POPUP_SUBTITLE" : "משוב על הווידג'ט והתכונות שלו",
    "FEEDBACK_SATISFIED" : "מקורב",
    "FEEDBACK_UNSATISFIED" : "לא מקורב",
    "FEEDBACK_PROVIDE_REASONS" : "ספר עוד מידע…",
    "FEEDBACK_TITLE" : "משוב",
    "AGENTIC_THINKING" : "חושב",
    "AGENTIC_AGENT_TITLE" : "סוכן",
    "AGENTIC_COPILOT_MODE_TITLE" : "מצב טייס משנה אגנטי",
    "AGENTIC_SENDING_MESSAGE" : "שולח...",
    "AGENTIC_COPILOT_DESC" : "Agentic Copilot מאזין באופן פעיל לשיחה שלך ומוכן לסייע אוטומטית",
    "AGENTIC_SEARCH_RESULTS" : "תוצאות סוכן",
    "PAUSE_AUTO_SEND" : "השהה שליחה אוטומטית",
    "PAUSE_AGENTIC" : "השהה סוכן",
    "RESUME_AGENTIC" : "המשך סוכן",
    "RESUME_AUTO_SEND" : "המשך שליחה אוטומטית"
}